export enum UpdateType {
  CLOCK,
  PLAYER_UPDATE,
  PLAYER_JOINED,
  PLAYER_DISCONNECTED,
  PLAYER_HIT,
  PLAYER_RESPAWN,
  BULLET_FIRED,
  BACKGROUND_UPDATE,
  GAME_INFO,
  CHAT,
}

export enum InputDirection {
  NEGATIVE,
  POSITIVE,
  NONE,
}

export type PlayerUpdate = {
  type: UpdateType.PLAYER_UPDATE;
  x: number;
  vx: number;
  pid: number;
  tick: number;
  dir: InputDirection;
  angle: number;
  angleDir: InputDirection;
};
export type BulletFiredUpdate = {
  type: UpdateType.BULLET_FIRED;
  x: number;
  y: number;
  bulletType: string;
  vx: number;
  vy: number;
  tick: number;
  owner: number;
};
export type ClockUpdate = {
  type: UpdateType.CLOCK;
  time: number;
};
export type BackgroundUpdate = {
  type: UpdateType.BACKGROUND_UPDATE;
  x: number; // inclusive start of update range
  data: number[];
};
export type PlayerJoinedUpdate = {
  type: UpdateType.PLAYER_JOINED;
  x: number;
  id: number;
  name: string;
  colour: string;
};
export type GameInfoUpdate = {
  type: UpdateType.GAME_INFO;
  players: {
    id: number;
    name: string;
    colour: string;
    kills: number;
    deaths: number;
  }[];
};
export type PlayerDisconnectedUpdate = {
  type: UpdateType.PLAYER_DISCONNECTED;
  pid: number;
};
export type PlayerHitUpdate = {
  type: UpdateType.PLAYER_HIT;
  pid: number;
  hp: number;
};
export type ChatUpdate = {
  type: UpdateType.CHAT;
  pid: number;
  text: string;
};
export type PlayerRespawnUpdate = {
  type: UpdateType.PLAYER_RESPAWN;
  x: number;
  pid: number;
  causeType: string;
  causePid: number;
};
export type Update =
  | PlayerUpdate
  | ClockUpdate
  | BulletFiredUpdate
  | BackgroundUpdate
  | PlayerJoinedUpdate
  | PlayerHitUpdate
  | PlayerRespawnUpdate
  | GameInfoUpdate
  | PlayerDisconnectedUpdate
  | ChatUpdate;
